import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Col, Row } from '@thd-olt-component-react/grid';
import styles from './no-results-found-banner.module.scss';
import { CustomCatalogButton } from './subcomponets/CustomCatalogButton';
import { SuggestionsContainer } from './subcomponets/SuggestionsContainer';
import {
  CHECK_SPELLING_TITLE,
  CONTACT,
  EXACT_PHRASE_MOBILE,
  EXACT_PHRASE_TITLE,
  GET_HELP,
  LOCAL_STORE,
  ONLINE_ORDER_SUPPORT,
  REFINE_SEARCH,
  SHOP_CUSTOM_PRODUCTS,
  TRY_DIFFERENT_WORDS_TITLE
} from './constants';

const cx = classNames.bind(styles);

const NewNoResultsFoundBanner = ({ keyword, cpoOnly, onCpoClick }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('new-no-results-found-banner.ready'); }, []);
  return (
    <Row>
      <Col xs="12" className={cx('new-no-results-found-banner__title-container')}>
        <span className={`${cx('new-no-results-found-banner__icon')} mw-icon-search`} />
        Hmm...we couldn&apos;t find&nbsp;
        <span className={cx('new-no-results-found-banner__term')}>
          &quot;{keyword}&quot;
        </span>
        {cpoOnly && (
          <CustomCatalogButton value="false" onCpoClick={onCpoClick} title={SHOP_CUSTOM_PRODUCTS} newDesign />
        )}
      </Col>
      <Col xs="12" sm="6" className={cx('new-no-results-found-banner__col')}>
        <SuggestionsContainer header={REFINE_SEARCH}>
          {TRY_DIFFERENT_WORDS_TITLE}
          {CHECK_SPELLING_TITLE}
          {`${EXACT_PHRASE_TITLE} ${EXACT_PHRASE_MOBILE}`}
        </SuggestionsContainer>
      </Col>
      <Col xs="12" sm="6" className={cx('new-no-results-found-banner__col')}>
        <SuggestionsContainer header={GET_HELP}>
          {
            <>
              <a href="https://www.homedepot.com/l/search/" className="u__default-link">
                {CONTACT}
              </a> {LOCAL_STORE}
            </>
          }
          {ONLINE_ORDER_SUPPORT}
        </SuggestionsContainer>
      </Col>
    </Row>
  );
};

NewNoResultsFoundBanner.displayName = 'NewNoResultsFoundBanner';
NewNoResultsFoundBanner.propTypes = {
  keyword: PropTypes.string.isRequired,
  cpoOnly: PropTypes.bool,
  onCpoClick: PropTypes.func,
};

NewNoResultsFoundBanner.defaultProps = {
  cpoOnly: false,
  onCpoClick: () => {},
};

export { NewNoResultsFoundBanner };
